import { cn } from "@/lib/utils";
import { WorkspaceComment } from "@/models/workspace/WorkspaceComment";
import { FC } from "react";
import CommentThread from "./CommentThread";
import { standardHoverFocus, standardStyling } from "./utils/StandardStyles";
import useCommentsStore from "@/stores/comments.store";

type NestedCommentThreadComponentsProps = {
  comment: WorkspaceComment;
  nestLevel: number;
};

const NestedCommentThreadComponents: FC<NestedCommentThreadComponentsProps> = ({
  comment,
  nestLevel,
}) => {
  const { hoveredThread, setHoveredThread, toggleReplies } = useCommentsStore();

  return (
    <div className="relative ml-4">
      <div
        className={cn(
          "relative -ml-[1px] pl-3 border-l-2 transition-border duration-200",
          hoveredThread === comment.id
            ? "border-primary"
            : "border-border"
        )}
        onMouseEnter={() => setHoveredThread(comment.id)}
        onMouseLeave={() => setHoveredThread(null)}
      >
        <div
          className={standardHoverFocus}
          onClick={(e) => {
            e.stopPropagation();
            toggleReplies(comment.id);
          }}
          onMouseEnter={() => setHoveredThread(comment.id)}
          onMouseLeave={() => setHoveredThread(null)}
        />
        {comment.replies?.map((reply, index) => (
          <div
            key={reply.id}
            className="relative mt-2"
            data-comment-id={reply.id}
          >
            {/* Curved L connector */}
            {index < (comment.replies?.length || 0) - 1 && (
              <div
                className={cn(
                  standardStyling,
                  "-left-[14px] -bottom-[24px]",
                  "w-[32px] h-[22px]",
                  hoveredThread === comment.id
                    ? "border-primary"
                    : "border-border"
                )}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleReplies(comment.id);
                }}
                onMouseEnter={() => setHoveredThread(comment.id)}
                onMouseLeave={() => setHoveredThread(null)}
              >
                <div
                  className="absolute -left-2 -right-2 -top-2 -bottom-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleReplies(comment.id);
                  }}
                />
              </div>
            )}

            <CommentThread comment={reply} nestLevel={nestLevel + 1} />
          </div>
        ))}
      </div>
    </div>
  );
};
export default NestedCommentThreadComponents;
